import { graphql, useMutation } from 'react-relay'
import { v4 as uuidv4 } from 'uuid'
import PencilSquare from '../../assets/pencil-square.svg?react'
import { insertStream } from '../../utils/insert-stream'
import { IconButton } from '../icon-button'
import { translate } from '../internationalization'

interface Props {
    label?: string
    navigate?: Function
}

export const NewChat: React.FC<Props> = ({ label, navigate }) => {
    const [commit] = useMutation(graphql`
    mutation newChatMutation($topic: String, $stream_guid: uuid) {insert_stream_one(object: {topic: $topic, stream_guid: $stream_guid}) {id}}`)

    // Generate brand new guid because we are about to create a new chat from scratch.
    const stream_guid = uuidv4()

    const onClick = async (e: { preventDefault: () => void }) => {
        const result = await insertStream({
            topic: translate('New chat'),
            stream_guid,
            commit
        })

        // Optional: cancel navigation if something goes wrong
        if (result.errorText) {
            e.preventDefault()
            console.error(result.errorText)
        }

        if (navigate) navigate(stream_guid, result.__id)
    }

    const { VITE_CHAT_ROUTE } = import.meta.env

    return <IconButton icon={PencilSquare} to={`${VITE_CHAT_ROUTE}${stream_guid}`} onClick={onClick}>{label}</IconButton>
}